<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useModalStore } from "~/stores/modal";
import { useTagsStore } from "~/stores/tags";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { tagsConfirmDelete } = useModalStore();
const tagsStore = useTagsStore();

const submitTagDelete = async () => {
	await tagsStore.deleteById(tagsConfirmDelete.tag.id);

	tagsConfirmDelete.closeModal();

	if (route.name === "products-tags-tag") {
		navigateTo("/products/tags");
	} else if (route.name === "products-tags") {
		tagsStore.getAll({}, tagsStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.TAGS.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.TAGS.CONFIRM_DELETE.alert.description", { tagName: tagsConfirmDelete.tag.name }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.TAGS.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.TAGS.CONFIRM_DELETE.description', { tagName: tagsConfirmDelete.tag.name })"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="tagsConfirmDelete.closeModal"
		@submit="submitTagDelete"
	/>
</template>
